export function normalize_role(roleId) {
    // The High/Medium/Low gradation is obsolete and being removed. Strip the
    // legacy suffix defensively so stale data (localStorage, not yet migrated
    // backend) still resolves to the base role.
    return (roleId || '').replace(/(_HIGH|_MEDIUM|_LOW)$/, '')
}

export function default_route(roleId) {
    switch (normalize_role(roleId)) {
        case 'CUSTOMER':
        case 'MEDIA_PRODUCTION':
        case 'ADMIN':
            return { name: 'products' }
        case 'AGENCY':
        case 'SUPPLIER':
            return { name: 'jobs' }
        default:
            return { name: 'error', params: { statusCode: 404 } }
    }
}
